import { QuestionNavigator } from '@exam-management/qset-question-details';
import { mappedQSetReviewSubtaskStatus } from '@exam-management/task-management';
import { ArrowBackOutlinedIcon, ArrowForwardOutlinedIcon, Button, Flex } from '@shared/components';

import { useQSetReviewSubtask } from '../../providers';
import { getQSetReviewSubtaskReviewQuestionVariant } from '../../utils';

export default function QSetReviewSubtaskQuestionNavigator() {
  const {
    qSetQuestion: { questions, currentQuestionNumber, currentQuestion },
    setCurrentQuestionNumber,
    status,
    roles,
  } = useQSetReviewSubtask();

  const onPrevious = () => setCurrentQuestionNumber(currentQuestionNumber - 1);
  const onNext = () => setCurrentQuestionNumber(currentQuestionNumber + 1);

  const onJump = (questionNumber: number) => setCurrentQuestionNumber(questionNumber);

  const totalQuestions = questions.length;

  const taskStatus =
    mappedQSetReviewSubtaskStatus[status.code as keyof typeof mappedQSetReviewSubtaskStatus];
  const variant = getQSetReviewSubtaskReviewQuestionVariant(roles, taskStatus);

  if (variant === null || variant === 'HIDDEN' || !currentQuestion) {
    return null;
  }

  return (
    <Flex
      sx={(theme) => ({
        position: 'sticky',
        bottom: 0,
        bgcolor: theme.palette.background.paper,
        p: theme.spacing(4, 6),
        borderTop: `1px solid ${theme.palette.grey[100]}`,
      })}
    >
      <QuestionNavigator
        onJump={onJump}
        totalQuestions={totalQuestions}
        currentQuestion={currentQuestionNumber}
      />
      <Flex sx={{ gap: (theme) => theme.spacing(4), ml: 'auto' }}>
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<ArrowBackOutlinedIcon />}
          onClick={onPrevious}
          disabled={currentQuestionNumber === 1}
          sx={{ minWidth: '112px' }}
        >
          Previous
        </Button>
        <Button
          startIcon={<ArrowForwardOutlinedIcon />}
          onClick={onNext}
          disabled={currentQuestionNumber === totalQuestions}
          sx={{ minWidth: '112px' }}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
}
